<template>
  <div></div>
</template>

<script>
export default {
  name: "Referer",
  mounted() {
    window.sessionStorage.setItem("referer", this.$route.params.trigram);
    this.$router.push("/signup");
  }
};
</script>

<style scoped></style>
